import { Switch } from "@/components/ui/switch";
import { useState, useEffect } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ButtonType } from "@/components/lib/Button";
import { useSelector } from "react-redux";
function Step1({ form, dayTimes, setDayTimes }) {
  const [showItem, setShowItem] = useState(false);
  const [enableDayTime, setEnableDayTime] = useState(false);
  const { days } = useSelector((state) => state.utility.day);

  const toggleDayTime = (id) => {
    if (id === undefined) return;
    setDayTimes((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((i) => i !== id)
        : [...prev, id];
      return updated;
    });
  };

  const itemNo = form.watch("item_no");

  useEffect(() => {
    setShowItem(itemNo && itemNo !== null);
    setEnableDayTime(dayTimes.length > 0);
  }, [itemNo, dayTimes]);

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {" "}
          {form.watch("type") == "update"
            ? "Update Banquet Night"
            : "Add New Banquet Night"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-8">
          <div className="">
            <div className="flex gap-2 items-center mb-3">
              <Switch
                checked={showItem}
                onCheckedChange={(val) => {
                  setShowItem(val);
                  if (!val) {
                    form.setValue("item_no", null);
                  }
                }}
              />
              <Label>Item No</Label>
            </div>
            {showItem && (
              <FormInputField
                name="item_no"
                style="bg-cblack7"
                placeholder={"Enter item no (must be number)"}
                form={form}
                type="text"
              />
            )}
          </div>
          <FormInputField
            name="name"
            style="bg-cblack7"
            placeholder={"Enter Name"}
            form={form}
            type="text"
            label={"Name"}
          />
          <FormInputField
            name="description"
            style="bg-cblack7"
            placeholder={"Enter description"}
            form={form}
            type="text"
            label={"Description"}
          />
          <div>
            {/* Day & Time */}
            <div className="flex items-center gap-2 mt-5">
              <Switch
                checked={enableDayTime}
                onCheckedChange={(val) => {
                  setEnableDayTime(val);
                  if (!val) {
                    setDayTimes([]);
                  }
                }}
                className="data-[state=unchecked]:bg-neutral-500"
              />
              <Label>Day</Label>
            </div>

            {enableDayTime && (
              <div className="mt-3 space-y-4">
                {/* Day Buttons */}
                <div className="flex flex-wrap gap-2">
                  {days.map((d) => {
                    const isSelected = dayTimes.includes(d?.id);

                    return (
                      <ButtonType
                        key={d?.id}
                        size="sm"
                        onClick={() => toggleDayTime(d?.id)}
                        className={`${
                          isSelected
                            ? "!bg-cyellow !text-black"
                            : "!bg-cblack7 text-cwhite"
                        }`}
                      >
                        {d?.short_name}
                      </ButtonType>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default Step1;
